const waitFrame = async (frame) => {
  const promiseArray = [];
  let frameCount = 0;

  console.log('waitFrame start');
  console.time('waitFrame time');

  const waitFunc = () => {
    return new Promise((resolve) => {
      requestAnimationFrame(() => {
        frameCount++;

        resolve();
      });
    });
  };

  for (let i = 0; i < frame; i++) {
    promiseArray.push(await waitFunc());
  }

  return Promise.all(promiseArray).then(() => {
    console.log('waitFrame finish');
    console.timeEnd('waitFrame time');
    console.log('waitFrame frameCount', frameCount);
  });
};

export const nextTick = async () => {
  await waitFrame(1);
};
